export default {
  messageType: '캐러셀 커머스',
  carouselSetting: '캐러셀 설정',
  title: '캐러셀 커머스 설정',
  label: {
    introSetting: '인트로 설정',
    attachIntroImage: '인트로 이미지 첨부',
    introTitle: '인트로 제목',
    introContent: '인트로 내용',
    introMobileWebLink: '인트로 모바일 웹 링크',
    introPcWebLink: '인트로 PC 웹 링크',
    introIosDeepLink: '인트로 iOS 앱 링크',
    introAndroidDeepLink: '인트로 안드로이드 앱 링크',
    image: '이미지',
    title: '상품명',
    regularPrice: '정상가격',
    discountPrice: '할인가격',
    discountRate: '할인율',
    discountFixed: '정액할인가격',
    additionalContent: '부가 정보',
    imageLink: '이미지 링크',
  },
  placeholder: {
    price: '0 ~ 99,999,999',
    rate: '0 ~ 100',
    fixed: '0 ~ 999,999',
    imageLink: '이미지 클릭 시 등록한 링크로 이동됩니다.',
  },
  alt: {
    image: '캐러셀커머스 이미지 {count}',
  },
  comment: {
    image: '800x400 (2:1 비율) 또는 800x800 (1:1 비율) 또는 800x600 (4:3비율) 권장 / 최대 5MB, 캐러셀 커머스형 이미지는 모든 이미지의 비율이 일치해야 합니다.',
    price: '※ 할인 가격 입력시, 할인율 또는 정액할인가격 중 하나는 반드시 입력.',
  },
  validation: {
    list: {
      max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
      introMax: '인트로가 포함된 경우, 캐러셀은 최대 5개 까지만 추가할 수 있습니다.',
      min: '인트로가 포함된 경우, 캐러셀은 최소 1개 필요합니다.',
      introMin: '캐러셀은 최소 2개 이상이어야 합니다.',
    },
  },
};
